module.exports = __webpack_public_path__ + "img/chinesecompany63.f151ed62.png";